var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyjob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.75V15.25H0V2.75H6.25V1.5C6.25 1.32422 6.28255 1.16146 6.34766 1.01172C6.41276 0.861979 6.50065 0.731771 6.61133 0.621094C6.72852 0.503906 6.86198 0.41276 7.01172 0.347656C7.16146 0.282552 7.32422 0.25 7.5 0.25H12.5C12.6758 0.25 12.8385 0.282552 12.9883 0.347656C13.138 0.41276 13.2682 0.503906 13.3789 0.621094C13.4961 0.731771 13.5872 0.861979 13.6523 1.01172C13.7174 1.16146 13.75 1.32422 13.75 1.5V2.75H20ZM7.5 2.75H12.5V1.5H7.5V2.75ZM1.25 4V5.80664L7.5 8.92188V7.75H12.5V8.92188L18.75 5.80664V4H1.25ZM8.75 9V10.25H11.25V9H8.75ZM18.75 14V7.19336L12.5 10.3281V11.5H7.5V10.3281L1.25 7.19336V14H18.75Z",
    fill: "#D12232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyjob);
export default __webpack_public_path__ + "static/media/myjob.a94d52f61f8476787ccc2ad578e5ad61.svg";
export { ForwardRef as ReactComponent };